import { render, staticRenderFns } from "./JdpDashboard.vue?vue&type=template&id=c7984640&"
import script from "./JdpDashboard.vue?vue&type=script&lang=ts&"
export * from "./JdpDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports